/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:22:59
 * @Description: 导出所有 store 模块
 */

export { default as auth } from "./auth.store";
